import React, {useEffect, useState} from "react";
import CaroselloStandard from "../commons/CaroselloStandard";
import foto1 from "../images/Danza/Danza1.jpg"
import foto2 from "../images/Danza/Danza2.jpg"
import foto3 from "../images/Danza/Danza3.jpg"
import foto4 from "../images/Danza/Danza4.jpg"
import foto5 from "../images/Danza/Danza5.jpg"
import foto6 from "../images/Danza/Danza6.jpg"
import foto7 from "../images/Danza/IMG_1715.jpg"
import copertina from "../images/Danza/IMG_1746.jpg"


import Titolo from "../commons/Titolo";
import DanzaAccordion from "../components/danza/DanzaAccordion";
import DanzaPacchettixxl from "../components/danza/DanzaPachettixxl";
import DanzaPacchettiMedia from "../components/danza/DanzaPacchettiMedia";
import DanzaInfoCorsi from "../components/danza/DanzaInfoCorsi";
import ScrollToTopOnMount from "../components/ScrollToTopOnMount";
import Space from "../commons/Space";
import InsegnantiDanza from "../components/danza/InsegnantiDanza";
import TitoloSezioni from "../commons/TitoloSezioni";
import GenitoriAttivi from "../commons/GenitoriAttivi";
import SpaceL from "../commons/SpaceL";
import TabellaDanzaNuova from "../components/danza/TabellaDanzaNuova";
import DanzaAccordionNuovo from "../components/danza/DanzaAccordionNuovo";
import DanzaAccordionPrezzi from "../components/danza/DanzaAccordionPrezzi";
import Spa from "./Spa";


function Danza() {

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return(
        <div>
            <ScrollToTopOnMount />
            <Titolo backgroundImage={copertina} title={"Danza"}/>
            <SpaceL />
            <div style={{padding: "1em"}}>
                {/*<div id="info"></div>*/}
                <div className="d-none d-sm-block"><Space /></div>
                <div className="d-block d-sm-none"><SpaceL /></div>
            <TitoloSezioni title={"Corsi"} />
            <div style={{fontSize: "20px"}} className="text-center">Direttrice della scuola di danza: Barbara Melica
            <br/></div>

            <div className="text-center" style={{fontSize: "18px"}}>
                Grazie alla sua esperienza gli allievi hanno la possibilità di danzare in concorsi nazionali e internazionali
            </div><br/>
                <TabellaDanzaNuova />
                <br/>
                <div className="text-center"> *l'inserimento in questi corsi è previsto previa audizione con la Direttrice Artistica, Barbara Melica</div>

                <Space />

                <DanzaInfoCorsi />

                <Space />

                <DanzaAccordionPrezzi />


                {/*
            <div style={{fontSize: "16px", marginBottom: "2em"}} className="text-center">
                Per i nuovi allievi gli inserimenti nei livelli dei corsi di base monosettimanali e bisettimanali vengono stabiliti dalle insegnanti
                <br/>
                <br/>
                Sconto del 25% per allievi maschi
                <br/>
            </div>

                <DanzaInfoCorsi /> */}

                {/*
            <TitoloSezioni title={"Pacchetti Experience"} />
            <SpaceL />
            {windowWidth > 900 ? (
                <DanzaPacchettixxl />
            ) : (
                <DanzaPacchettiMedia />
            )}
            <Space />
            <GenitoriAttivi /> */}
            <Space />
                <CaroselloStandard foto1={foto1} foto2={foto2} foto3={foto3} foto4={foto4} foto5={foto5} foto6={foto6} foto7={foto7}/>
            <Space />
            </div>

        </div>
    )
}


export default Danza
